// Wait until the DOM is fully loaded
let isBuyNowClicked = false; // global variable
document.addEventListener("DOMContentLoaded", function() {
  // Select all elements with the class 'save-for-later-btn'
  var saveForLaterButtons = document.querySelectorAll('.save-for-later-btn');
  // Add a click event listener to each button
  saveForLaterButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default action if necessary
      // Get the product ID from the 'data-item-id' attribute
      var productId = button.getAttribute('data-item-id');
       var productHandle = button.getAttribute('product-handle');
      // Get the customer ID from the 'customer-id' attribute
      var customerId = button.getAttribute('customer-id');
      
      // Check if customer ID is available
      if (!customerId) {
        //console.log("Customer not logged in.");
        alert("Please log in to save items for later.");
        return; // Stop if no customer ID
      }
      if(window.location.pathname==='/ar/pages/my-wishlist'){
        var lang='ar';
      }else{
        var lang='en';
      }
      // Prepare data to send
      var data = {
        action: "save_for_later",
        customer_id: customerId,
        item_id: productId,
        product_handle: productHandle,
        lang: lang
      };
      //console.log(data);
      // AJAX POST request
      fetch("https://app.rafpharmacy.com/api/wishlist/post", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        // Check if the response is okay (status in the range 200-299)
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // Parse the JSON response
        return response.json();
      })
      .then(data => {
        // Log and alert the successful response
        //console.log("Response from server:", data);
        //alert("Item saved for later successfully!");
        //removeItemFromCart(productId, button);
        document.getElementById("Remove-"+productId).click();
        location.reload();
      })
      .catch(error => {
        // Log any error and alert the user
        //console.error("Error saving item for later:", error);
        //alert("Failed to save item for later. Please try again.");
      });
    });
  });
});

// Ensure the script only runs on the main cart page
document.addEventListener("DOMContentLoaded", function() {
  
  if (window.location.pathname === '/cart') {
    
    const customerId = ShopifyAnalytics.meta.page.customerId; // Assuming customer ID is available here
    const savedItemsList = document.getElementById('saved-items-list');
    if (!customerId) {
      //console.log("Customer not logged in.");
      return;
    }
  //  console.log(customerId);
    if(window.location.pathname==='/ar/pages/my-wishlist'){
      var lang='ar';
    }else{
      var lang='en';
    }
  var action = 'save_for_later';
    var lang= lang;
    // Function to fetch saved later items from the server
   // function fetchSavedItems() {
      fetch("https://app.rafpharmacy.com/api/wishlist/get", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ customer_id: customerId,action: action,lang: lang })
      })
      .then(response => response.json())
      .then(data => {
        if (data && data.item_ids) {
          // Retrieve item details from Shopify and render them
          //console.log(data);
         // console.log("I am saved data");
          displaySavedItems(data.item_ids);
        } else {
          //console.log("No saved items found.");
        }
      })
      .catch(error => {
        //console.error("Error fetching saved items:", error);
      });
    //}

//new code
async function displaySavedItems(itemIds) {
    document.getElementById("saved-items-count").innerHTML = "("+itemIds.length+")";
    // Parent element where the HTML will be appended
    const savedItemsList = document.getElementById("saved-items-list");
    savedItemsList.innerHTML = ''; // Clear existing content

    let fullItemHTML = ''; // To accumulate the final HTML

    // Fetch item details for each itemId
    for (const item of itemIds) {
        const productHandle = item.productHandle;

        try {
            // Simulate API call to fetch Shopify product details
            const product = await fetchShopifyProductDetails(productHandle);

            // Construct the HTML for each product
            const productHTML = `
                <div class="product-card grid__item" data-item-id="${product.variants[0].id}" id="product-card-${product.variants[0].id}">
                    <div class="card_inner">
                      <img src="${product.featured_image}" alt="${product.title}" class="product-image">
                    </div>
                    <div class="card__content">
                      <div class="rr-container">
                        <button class="remove-btn" data-item-id="${product.variants[0].id}" onclick="handleDeleteRequest(${product.variants[0].id})">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.39155 1.60845L12.1747 12.3916M1.39155 12.3916L12.1747 1.60845" stroke="#FF4545" stroke-width="1.81333" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg>
                        </button>
                      </div>
                      <h3 class="product-title"><a href="/products/${product.handle}?variant=${product.id}" target="_blank">${product.title}</a></h3>
                      <div class="card-info-container">
                        <div class="price--info">
                          <div class="price-wrapper"></div>
                          <p class="product-price">${product.price / 100} QAR</p>
                        </div>
                        <div class="cart-options">
                          
                          <button class="quick-add-to-cart-btn button--secondary" data-item-id="${product.id}" onclick="addToCart(${product.variants[0].id},1,${product.id},'save_for_later')">
                            <span class="cart-icon">
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.3997 9.18092V18.2476M9.86641 13.7143H18.9331M25.7331 13.7143C25.7331 19.9735 20.659 25.0476 14.3997 25.0476C8.14051 25.0476 3.06641 19.9735 3.06641 13.7143C3.06641 7.45503 8.14051 2.38092 14.3997 2.38092C20.659 2.38092 25.7331 7.45503 25.7331 13.7143Z" stroke="#2C2C2C" stroke-width="1.81333" stroke-linecap="round" stroke-linejoin="round"></path>
                              </svg>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            `;

            // Append to the full HTML string
            fullItemHTML += productHTML;

        } catch (error) {
            //console.error(`Error fetching details for product handle: ${productHandle}`, error);
        }
    }

    // Add the final HTML to the saved-items-list div
    savedItemsList.innerHTML = fullItemHTML;
}

// Simulate a function to fetch Shopify product details
async function fetchShopifyProductDetails(productHandle) {
    try {
        const response = await fetch(`/products/${productHandle}.js`);

        if (!response.ok) {
            throw new Error(`Failed to fetch product with handle "${productHandle}"`);
        }

        const product = await response.json();

        // Transform the data into the desired format
        return {
            id: product.id,
            handle: product.handle,
            title: product.title,
            featured_image: product.images[0] || 'https://via.placeholder.com/150', // Use first image or placeholder
            price: product.variants[0]?.price || 0, // Use price of the first variant
            variants: product.variants
        };
    } catch (error) {
        //console.error("Error fetching product details:", error);
        throw error;
    }
} //fetchShopifyProductDetails
//end displaySavedItems
    //end
    
    
    //get shopify item details
    // Call the function to fetch and display saved items
    //fetchSavedItems();   
  }
});


// Function to handle the delete request
function handleDeleteRequest(itemId,productId='', action = 'save_for_later') {
  const customerId = ShopifyAnalytics.meta.page.customerId; // Assuming customer ID is available
  if (!customerId) {
    alert("Please log in to delete items from your wishlist.");
    return;
  }
if(action=='wishlist'){
  itemId = productId;
}
  
 // alert(itemId);
  const data = {
    action: action,
    customer_id: customerId,
    item_id: itemId
  };

  fetch("https://app.rafpharmacy.com/api/wishlist/delete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  })
  .then(response => {
    if (!response.ok) { // Properly check for HTTP errors
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json(); // Return JSON response
  })
  .then(data => {
    //console.log("Delete response from server:", data);
    
    if (data.status !== "success") {  // Check if the API response is successful
      throw new Error(data.message || "Unexpected error occurred");
    }
    if(action=="wishlist"){
      const rowId = `WishlistItem-${itemId}`;
      const rowElement = document.getElementById(rowId);
  
      if (rowElement) {
          rowElement.remove();
         let messageDiv = document.querySelector(".item-deleted");
        messageDiv.innerHtml = "Successfully added to cart";
        messageDiv.style.display = "block"; 
        
        location.reload(true);
        //let cartDropdown = document.querySelector(".totals__total-value");
       // cartDropdown.click();
         // console.log(`Item with ID ${rowId} deleted from wishlist.`);
      } else {
         // console.log(`No element found with ID ${rowId}`);
      }
      return true;
    }else{
      
      location.reload(true);
    }

    // Update wishlist count
    let total = document.getElementById("saved-items-count").innerHTML;
    total = parseInt(total.replace(/[()]/g, ''));
    total = total - 1;
    document.getElementById("saved-items-count").innerHTML = `(${total})`;

    // Remove item from the DOM
    const productCard = document.getElementById(`product-card-${itemId}`);
    if (productCard) {
      productCard.remove();
    } else {
      //console.log(`Element with id 'product-card-${itemId}' not found.`);
    }
  })
  .catch(error => {
    //console.error("Error deleting item from wishlist:", error);
    alert("Failed to delete item from wishlist. Please try again.");
  });
}

// Attach click event listeners to all remove buttons

//wishlist handling code
document.addEventListener("DOMContentLoaded", function() {
  // Select all elements with the class 'wishlist'
  var addWishListButtons = document.querySelectorAll('.wishlist__btn222222');
  // Add a click event listener to each button
  addWishListButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default action if necessary
      // Get the product ID from the 'data-item-id' attribute
      var productId = button.getAttribute('data-item-id');
       var productHandle = button.getAttribute('product-handle');
      // Get the customer ID from the 'customer-id' attribute
      var customerId = button.getAttribute('customer-id');
      // Check if customer ID is available
      if (!customerId) {
       // console.log("Customer not logged in.");
       // alert("Please log in to save items for later.");
        return; // Stop if no customer ID
      }
      var action = button.classList.contains('count_added') ? "delete_wishlist" : "wishlist";
      // Prepare data to send
      wishListAjaxPost(action,customerId,productId,productHandle,button)
    
    });
  });
  
});

document.addEventListener("DOMContentLoaded", function() {
  // Use event delegation to handle dynamically added elements
  document.body.addEventListener('click', function(event) {
    let button = event.target.closest('.wishlist__btn');
    
    if (button) {
      event.preventDefault(); // Prevent default action if necessary
      
      // Get the product ID from the 'data-item-id' attribute
      var productId = button.getAttribute('data-item-id');
      var productHandle = button.getAttribute('product-handle');
      
      // Get the customer ID from the 'customer-id' attribute
      var customerId = button.getAttribute('customer-id');
      
      // Check if customer ID is available
      if (!customerId) {
        //console.log("Customer not logged in.");
        // alert("Please log in to save items for later.");
        return; // Stop if no customer ID
      }
      
      var action = button.classList.contains('count_added') ? "delete_wishlist" : "wishlist";
      
      // Prepare data to send
      wishListAjaxPost(action, customerId, productId, productHandle, button);
    }
  });
});





function wishListAjaxPost(action,customerId,productId,productHandle,button=null){
  
  const wishlistBubble = document.querySelector('.wishlist-bubble');
  if (wishlistBubble) {
    const currentCount = parseInt(wishlistBubble.textContent, 10);
  }
    var data = {
        action: action,
        customer_id: customerId,
        item_id: productId,
        product_handle: productHandle
      };
      // AJAX POST request
      fetch("https://app.rafpharmacy.com/api/wishlist/post", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        // Check if the response is okay (status in the range 200-299)
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // Parse the JSON response
        return response.json();
      })
      .then(data => {
        if (action === "wishlist") {
          // If item was added to wishlist, add 'count-added' class
          button.classList.add('count_added');
          addRemoveWishListFilled();
          //alert("Item added to wishlist successfully!");
        } else {
          // If item was removed from wishlist, remove 'count-added' class
          if(button){ //the ajax call from product page button will not be null
            button.classList.remove('count_added');
            addRemoveWishListFilled();
          }else{
            //delete from wish list page
            document.getElementById("WishlistItem-"+productId).remove();
             addRemoveWishListFilled();
          }
          
          //alert("Item removed from wishlist successfully!");
        }
      })
      .catch(error => {
        // Log any error and alert the user
        //console.error("Error saving item for later:", error);
        //alert("Failed to save item for later. Please try again.");
      });
}


//check currently loaded products added to wishlist or not

function processWishlistButtons() {
  // Select all elements with the class 'wishlist__btn'
  const wishlistButtons = document.querySelectorAll('.wishlist__btn');

  // Check if any wishlist buttons are found
  if (wishlistButtons.length === 0) {
    //console.log("No wishlist buttons found.");
    return;
  }

  // Create a JSON array to hold product data
  const productsData = [];
  const customerId = ShopifyAnalytics.meta.page.customerId; // Assuming customer ID is available here
      if (!customerId) {
      //console.log("Customer not logged in.");
      return;
    }
  // Loop through each wishlist button
  wishlistButtons.forEach(button => {
    const itemId = button.getAttribute('data-item-id');
    const productHandle = button.getAttribute('product-handle');
    //const customerId = button.getAttribute('customer-id');
   
  
 
    // Ensure required attributes are present
    if (itemId) {
      productsData.push({
        item_id: itemId
      });
    }
  });
  
  // Check if there's any data to send
  if (productsData.length === 0) {
   // console.log("No valid product data found.");
    return;
  }
    if(window.location.pathname==='/ar/pages/my-wishlist'){
      var lang='ar';
    }else{
      var lang='en';
    }
   const data = {
    action: "wishlist",
    customer_id: customerId,
    lang: lang
  };
  // AJAX request to send the product data
  fetch("https://app.rafpharmacy.com/api/wishlist/get", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(responseData => {
     // console.log("Response from server:", responseData);

      // Assuming the response contains an array of product IDs
      //const matchedProductIds = responseData.item_ids || [];
     // const matchedProductIds = responseData.item_ids.map(item => item.itemId.toString()); // Convert IDs to strings
      if (!Array.isArray(responseData.item_ids) || responseData.item_ids.length === 0) {
            responseData.item_ids = []; // Set it to an empty array if undefined or empty
          //  console.log('responseData.item_ids is empty or undefined, setting it to []');
        }
      const matchedProductIds = responseData.item_ids.map(item => item.itemId.toString()); // Convert IDs to strings
      // Add the 'count_added' class to matching buttons
      wishlistButtons.forEach(button => {
        const itemId = button.getAttribute('data-item-id');
        
        if (matchedProductIds.includes(itemId)) {
          button.classList.add('count_added');
        }
      });
    })
    .catch(error => {
      //console.error("Error checking wishlist buttons:", error);
    });
}

// Call the function after the DOM is fully loaded
document.addEventListener("DOMContentLoaded", processWishlistButtons);




//get wishlist items from server

document.addEventListener("DOMContentLoaded", function() {
  // Check if we are on the my-wishlist page
  if (window.location.pathname === '/pages/my-wishlist' || window.location.pathname === '/ar/pages/my-wishlist') {
    const customerId = ShopifyAnalytics.meta.page.customerId; // Assuming customer ID is available here

    if (!customerId) {
     // console.log("Customer not logged in.");
      return;
    }

    // Show the loader
    const loader = document.querySelector(".loader");
    if (loader) {
      loader.style.display = "block";
    }
    if(window.location.pathname==='/ar/pages/my-wishlist'){
      var lang='ar';
    }else{
      var lang='en';
    }
    // Prepare data to send
    const data = {
      action: "wishlist",
      customer_id: customerId,
      lang: lang
    };

    // AJAX GET request to fetch all saved wishlist items
    fetch("https://app.rafpharmacy.com/api/wishlist/get", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
     // console.log("Wishlist data:", data);
      const wishlistItems = data.item_ids || []; // Ensure it's an array
      const wishlistTableBody = document.querySelector(".wishlist-items tbody");
      const noWishlistMessage = document.querySelector(".no-wishlist-message");

      // Hide the loader
      if (loader) {
        loader.style.display = "none";
      }

      // Clear existing content in the table body
      wishlistTableBody.innerHTML = '';

      if (wishlistItems.length === 0) {
        // Show "No items in wishlist" message
        if (noWishlistMessage) {
          noWishlistMessage.style.display = "block";
        } else {
          // Create and insert the message if not already present
          const message = document.createElement("p");
          message.classList.add("no-wishlist-message");
          message.textContent = "No items in your wishlist.";
          document.querySelector(".wishlist-items").appendChild(message);
        }
      } else {
        // Hide the no items message if there are items
        if (noWishlistMessage) {
          noWishlistMessage.style.display = "none";
        }

        // Fetch each product's details using its handle and populate the table
        wishlistItems.forEach(item => {
          fetchProductDetails(item.productHandle, item.itemId, wishlistTableBody,item.arabicTitle);
        });
      }
    })
    .catch(error => {
     // console.error("Error fetching wishlist data:", error);

      // Hide the loader in case of error
      if (loader) {
        loader.style.display = "none";
      }
    });
  }
});

//end ajax request

// Function to fetch product details by handle and add to the wishlist table
function fetchProductDetails(handle, itemId, wishlistTableBody,arabicTitle) {
   if(window.location.pathname==='/ar/pages/my-wishlist'){
      var lang='ar';
    }else{
      var lang='en';
    }
  fetch(`/products/${handle}.js`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to fetch product details for handle: ${handle}`);
      }
      return response.json();
    })
    .then(product => {
  const tagList = product.tags.map(tag => tag.toLowerCase().replace(/ /g, '-')).join(' ');

      // Process Buy X Get Y tags
      let buyXGetYContent = '';
      product.tags.forEach(tag => {
        const formattedTag = tag.toLowerCase().replace(/ /g, '-');
        if (formattedTag.includes('buy-') && formattedTag.includes('-get-')) {
          const buyOfferParts = formattedTag.split('-');
          const buyQuantity = buyOfferParts[1];
          const getQuantity = buyOfferParts[3];

          // Extract extra content after "get-Y" (if any)
          const extraContent = buyOfferParts.slice(4).join(' ');

          if (!extraContent) {
            buyXGetYContent = `<span class="offer-tag offer-buy-${buyQuantity}-get-${getQuantity}">Buy ${buyQuantity} Get ${getQuantity}</span>`;
          }
        }
      });
      // Generate the HTML for each wishlist item
      const action = "delete_wishlist";
      const customerId = ShopifyAnalytics.meta.page.customerId; 
     
      if(product.featured_image == null){
      var featured_image = 'https://raf-pharmacy.myshopify.com/cdn/shop/files/place_holder-back_ad_white.png';
      }else{
        var featured_image=product.featured_image;
      }
      if(lang=="ar" && arabicTitle!=''){
        product.title = arabicTitle;
      }
      if(lang=="ar"){
        var add_to_cart_text = 'أضف إلى السلة';
        var share_text = 'مشاركة';
        var delete_text = 'حذف';
      }else{
         var add_to_cart_text = 'Add to Cart';
        var share_text = 'Share';
        var delete_text = 'Delete';
      }

      
      const itemHtml = `
        <tr class="wishlist-item cart-item" id="WishlistItem-${itemId}" data-item-id="${itemId}">
          <td class="wishlist-item__media cart-item__media">
         
            <a href="/products/${handle}" class="wishlist-item__link" aria-hidden="true" tabindex="-1"></a>
            <div class="wishlist-item__image-container gradient global-media-settings">
             ${buyXGetYContent} 
              <img
                src="${featured_image}"
                class="wishlist-item__image"
                alt="${product.title}"
                loading="lazy"
                width="110"
                height="110"
              >
            </div>
          </td>

          <td class="wishlist-item__details cart-item__details">
            <a href="/products/${handle}" class="wishlist-item__name h4 break">${product.title}</a>
            <ul class="wishlist_buttons cart_buttons">
              <li>
                <span class="wishlist_btn_item" id="share-btn">${share_text}</span>
                <div class="product-sharing tooltip" id="share-tooltip">
                              <ul class="share-icons">
                                <li class="facebook">
                                  <a href="https://www.facebook.com/sharer/sharer.php?u=https://raf-pharmacy.myshopify.com/products/${handle}" target="_blank" rel="noopener noreferrer" class="ti-facebook">
                                    <!-- Facebook SVG icon -->
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M12.8333 12.3752H15.125L16.0416 8.7085H12.8333V6.87516C12.8333 5.931 12.8333 5.04183 14.6666 5.04183H16.0416V1.96183C15.7428 1.92241 14.6144 1.8335 13.4227 1.8335C10.934 1.8335 9.16663 3.35241 9.16663 6.14183V8.7085H6.41663V12.3752H9.16663V20.1668H12.8333V12.3752Z" fill="#000"></path>
                                    </svg>
                                  </a>
                                </li>
                                <li class="twitter">
                                  <a href="https://twitter.com/intent/tweet?text=https://raf-pharmacy.myshopify.com/products/${handle}" target="_blank" rel="noopener noreferrer" class="ti-twitter-alt">
                                    <!-- Twitter SVG icon -->
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M16.6879 2.0625H19.7203L13.0955 9.63417L20.889 19.9375H14.7859L10.0064 13.6886L4.53752 19.9375H1.50335L8.58919 11.8387L1.11377 2.0625H7.37002L11.6903 7.77425L16.6861 2.0625H16.6879ZM15.6237 18.1225H17.3039L6.45794 3.78217H4.65485L15.6237 18.1225Z" fill="#000"></path>
                                    </svg>
                                  </a>
                                </li>
                                <li class="whatsappweb">
                                  <a href="https://api.whatsapp.com/send?text=https://raf-pharmacy.myshopify.com/products/${handle}" target="_blank" rel="noopener noreferrer" data-action="share/whatsapp/share" class="icofont-brand-whatsapp">
                                    <!-- WhatsApp SVG icon -->
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M16.4625 3.50105C15.6221 2.65215 14.6211 1.97908 13.5178 1.5211C12.4146 1.06312 11.2312 0.829389 10.0367 0.833551C5.03165 0.833551 0.952484 4.91272 0.952484 9.91772C0.952484 11.5219 1.37415 13.0802 2.16248 14.4552L0.87915 19.1669L5.69165 17.9019C7.02082 18.6261 8.51498 19.0111 10.0367 19.0111C15.0417 19.0111 19.1208 14.9319 19.1208 9.92688C19.1208 7.49772 18.1767 5.21522 16.4625 3.50105ZM10.0367 17.4711C8.67998 17.4711 7.35082 17.1044 6.18665 16.4169L5.91165 16.2519L3.05165 17.0035L3.81248 14.2169L3.62915 13.9327C2.87542 12.7291 2.4752 11.3379 2.47415 9.91772C2.47415 5.75605 5.86582 2.36438 10.0275 2.36438C12.0442 2.36438 13.9417 3.15272 15.3625 4.58272C16.066 5.28302 16.6235 6.11599 17.0028 7.03336C17.382 7.95072 17.5753 8.93423 17.5717 9.92688C17.59 14.0886 14.1983 17.4711 10.0367 17.4711ZM14.18 11.8244C13.9508 11.7144 12.8325 11.1644 12.6308 11.0819C12.42 11.0086 12.2733 10.9719 12.1175 11.1919C11.9617 11.4211 11.5308 11.9344 11.4025 12.0811C11.2741 12.2369 11.1367 12.2552 10.9075 12.1361C10.6783 12.0261 9.94498 11.7786 9.08332 11.0086C8.40498 10.4036 7.95582 9.66105 7.81832 9.43188C7.68998 9.20272 7.79998 9.08355 7.91915 8.96438C8.01998 8.86355 8.14832 8.69855 8.25832 8.57022C8.36832 8.44188 8.41415 8.34105 8.48748 8.19438C8.56082 8.03855 8.52415 7.91022 8.46915 7.80022C8.41415 7.69022 7.95582 6.57188 7.77248 6.11355C7.58915 5.67355 7.39665 5.72855 7.25915 5.71938H6.81915C6.66332 5.71938 6.42498 5.77438 6.21415 6.00355C6.01248 6.23272 5.42582 6.78272 5.42582 7.90105C5.42582 9.01938 6.24165 10.1011 6.35165 10.2477C6.46165 10.4036 7.95582 12.6952 10.2292 13.6761C10.77 13.9144 11.1917 14.0519 11.5217 14.1527C12.0625 14.3269 12.5575 14.2994 12.9517 14.2444C13.3917 14.1802 14.2991 13.6944 14.4825 13.1627C14.675 12.6311 14.675 12.1819 14.6108 12.0811C14.5467 11.9802 14.4092 11.9344 14.18 11.8244Z" fill="#000"></path>
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
              </li>
              <li>
                <a
                  href="#" onclick="wishListAjaxPost('${action}',${customerId},${itemId},'${handle}')"
                  class="button button--tertiary cart_btn_item"
                  aria-label="Remove ${product.title}"
                >
                  <span class="wishlist_btn_item remove_text">${delete_text}</span>
                </a>
              </li>
            </ul>
          </td>

          <td class="wishlist-item__price right cart-item__totals right">
            <div class="wishlist-item__price-wrapper">
              <span class="price price--end">QAR ${(product.price / 100).toFixed(2)}</span>
            </div>
          </td>

          <td class="wishlist-item__quantity">
            <form action="/cart/add" method="post" enctype="multipart/form-data">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id">
              <button type="button" class="btn button btn-add-to-cart wishlist-add-cart" onclick="addToCart(${product.variants[0].id},1,${product.id},'wishlist')">${add_to_cart_text}</button>
            </form>
          </td>
        </tr>
      `;

      // Append the HTML to the wishlist table body
      wishlistTableBody.insertAdjacentHTML('beforeend', itemHtml);
    })
    .catch(error => console.error(`Error fetching product details for handle ${handle}:`, error));
}

//getting total wishlist count and show in header cound wishlist
document.addEventListener("DOMContentLoaded", function() {
  addRemoveWishListFilled();
});

//get total wishlist count for a logged in customer
async function getTotalWishListCount() {
  // Replace this with actual customer ID retrieval logic
  const customerId = ShopifyAnalytics.meta.page.customerId;

  if (!customerId) {
    //console.log("Customer not logged in.");
    return 0; // Return 0 if the customer is not logged in
  }
if(window.location.pathname==='/ar/pages/my-wishlist'){
      var lang='ar';
    }else{
      var lang='en';
    }
  // Prepare data to send
  const data = {
    action: "count_wishlist",
    customer_id: customerId,
    lang: lang
  };

  try {
    // Send AJAX request to get the wishlist count
    const response = await fetch("https://app.rafpharmacy.com/api/wishlist/get", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();
    //console.log("Wishlist count response:", responseData);

    // Assuming the server returns the total count in `responseData.total`
    return responseData.total || 0;
  } catch (error) {
    //console.error("Error fetching wishlist count:", error);
    return 0; // Return 0 in case of an error
  }
}


function addRemoveWishListFilled(){
   // Select the element with class 'wishlist-icon'
    const wishlistIcon = document.querySelector('.wishlist-icon');
    // Check if the element exists
    if (wishlistIcon) {
      // Check if the 'wishlist-filled' class exists
      
        // Add the 'wishlist-filled' class
    getTotalWishListCount().then(totalCount => {
      //console.log("Total wishlist count:", totalCount);
      
      // Update the wishlist bubble
       if (totalCount > 0 ) {
         if (!wishlistIcon.classList.contains('wishlist-filled')) {
            wishlistIcon.classList.add('wishlist-filled');
         }
      }else{
         if (wishlistIcon.classList.contains('wishlist-filled')) {
             wishlistIcon.classList.remove('wishlist-filled');
         }
      }
    });
    
    
        
        //console.log("'wishlist-filled' class added to .wishlist-icon.");
     
    } else {
      //console.error("Element with class 'wishlist-icon' not found.");
    }

}

function addToCart(itemId, quantity = 1,product_id='',action='') {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: itemId, // Variant ID
      quantity: quantity // Quantity to add
    })
  })
    .then(response => {
      if (!response.ok) {
        //throw new Error(`Error adding to cart: ${response.statusText}`);
      }
      return response.json();
    })
    .then(data => {
      handleDeleteRequest(itemId,product_id,action);
     // location.reload(true);
    })
    .catch(error => {
      //console.error("Error adding product to cart:", error);
      //alert("Failed to add product to cart. Please try again.");
    });
}

//validate mobile before checkout for guest checkout users
async function validateGuestMobile(mobileNumber) {
  const data = {
    action: "validate_guest_mobile",
    mobile: mobileNumber
  };
  try {
    const response = await fetch("https://app.rafpharmacy.com/api/customer/post", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();
    //console.log("Validation response:", responseData);
    return responseData; // return the whole response or adjust as needed
  } catch (error) {
    //console.error("Error validating mobile:", error);
    return { success: false, message: "Validation failed" };
  }
}
document.getElementById("validate-mobile").addEventListener("click", async function () {
  const input = document.querySelector('.phone-checking-field input[type="tel"]');
  const mobile = input.value.trim();

  // Validate Qatar mobile number: starts with 3,5,6,7 and 8 digits (with or without +974)
  const qatarPattern = /^(?:\+974)?(3\d{7}|5\d{7}|6\d{7}|7\d{7})$/;
 
  if (!qatarPattern.test(mobile)) {
    const messageEl = document.querySelector(".valid_mob_number_msg");
    if (messageEl) {
      messageEl.style.display = "block"; // or "block" if needed
    }
   
    return;
  }

  const result = await validateGuestMobile(mobile);

  if (result.status=="exists") {
    //alert("Mobile number validated successfully!");
    //redirect to checkout page
    // Additional actions like redirect/login
    //if buy now button clicked trigger click event of buy now button in product details page
    if(isBuyNowClicked){
      const buyNowBtn = document.querySelector(".shopify-payment-button__button");

      if (buyNowBtn) {
       
        // Trigger the click programmatically
        buyNowBtn.click();
      }
    }else{
      const checkoutBtn = document.getElementById("CartDrawer-Checkout");
      checkoutBtn.setAttribute("type", "submit");
      checkoutBtn.click();
    }
  } else {
    //javascript code to redirect to login page
    const currentPath = window.location.href;
    if (currentPath.includes('.com/ar')) {
      window.location.href = "/ar/account/login";
    }else{
      window.location.href = "/account/login";
    }
     
  }
});

//handling buy now button


  document.addEventListener("DOMContentLoaded", function () {
    const customBuyNowBtn = document.querySelector(".custom-buy-now-button");

    if (customBuyNowBtn) {
      customBuyNowBtn.addEventListener("click", function () {
        isBuyNowClicked = true;
        //console.log("Buy Now clicked:", isBuyNowClicked);
      });
    }

    // Example usage elsewhere
    function checkBuyNow() {
      if (isBuyNowClicked) {
        //console.log("Proceed with Buy Now logic");
      }
    }
  });

//set buy now button false when click from proceed to cart checkout
document.addEventListener("DOMContentLoaded", function () {
  // Get the Proceed To Buy button
  const proceedToBuyBtn = document.getElementById("CartDrawer-Checkout");

  if (proceedToBuyBtn) {
    proceedToBuyBtn.addEventListener("click", function () {
      isBuyNowClicked = false; // Reset the flag
     // console.log("Proceed To Buy clicked — isBuyNowClicked set to", isBuyNowClicked);
    });
  }
});
